import { render, staticRenderFns } from "./LinkedIn.vue?vue&type=template&id=3fa6b1a8&scoped=true"
var script = {}
import style0 from "./LinkedIn.vue?vue&type=style&index=0&id=3fa6b1a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa6b1a8",
  null
  
)

export default component.exports